import { useMemo, useState, type FC } from "react";
import i18n from "@/i18n";
import { useTranslation } from "react-i18next";
import { useBootstrap, useHostLanguageSync, useInitActions } from "@/hooks";
import { ChatbotModal, Dropdown } from "@/components";
import { readConfigFromScript } from "./config";

const App: FC = () => {
  const [currentLang, setCurrentLang] = useState(i18n.language);
  useInitActions();
  useBootstrap();
  useHostLanguageSync(currentLang, setCurrentLang);

  const { t } = useTranslation();

  const cfg = readConfigFromScript("md-login");
  const isAuto = useMemo(() => {
    try {
      return Boolean(
        cfg.triggerElementId && String(cfg.triggerElementId).trim(),
      );
    } catch {
      return false;
    }
  }, []);

  return (
    <>
      <Dropdown t={t} isAuto={isAuto} />
      {cfg.chatbot ? <ChatbotModal t={t} /> : null}
    </>
  );
};

export default App;
